export default __webpack_public_path__ + "static/media/H0002.d5ecf08d.png";